var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47927 14.42C8.6926 14.42 7.57927 13.8667 6.69927 11.22L6.21927 9.77999L4.77927 9.29999C2.13927 8.41999 1.58594 7.30665 1.58594 6.51999C1.58594 5.73999 2.13927 4.61999 4.77927 3.73332L10.4393 1.84665C11.8526 1.37332 13.0326 1.51332 13.7593 2.23332C14.4859 2.95332 14.6259 4.13999 14.1526 5.55332L12.2659 11.2133C11.3793 13.8667 10.2659 14.42 9.47927 14.42ZM5.0926 4.68665C3.23927 5.30665 2.57927 6.03999 2.57927 6.51999C2.57927 6.99999 3.23927 7.73332 5.0926 8.34665L6.7726 8.90665C6.91927 8.95332 7.03927 9.07332 7.08594 9.21999L7.64594 10.9C8.25927 12.7533 8.99927 13.4133 9.47927 13.4133C9.95927 13.4133 10.6926 12.7533 11.3126 10.9L13.1993 5.23999C13.5393 4.21332 13.4793 3.37332 13.0459 2.93999C12.6126 2.50665 11.7726 2.45332 10.7526 2.79332L5.0926 4.68665Z",
    fill: "#101323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74052 9.59998C6.61385 9.59998 6.48719 9.55331 6.38719 9.45331C6.19385 9.25998 6.19385 8.93998 6.38719 8.74665L8.77385 6.35331C8.96719 6.15998 9.28719 6.15998 9.48052 6.35331C9.67385 6.54665 9.67385 6.86665 9.48052 7.05998L7.09385 9.45331C7.00052 9.55331 6.86719 9.59998 6.74052 9.59998Z",
    fill: "#101323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.6df2e5cc4fe4a3bcb20846dec8b326f0.svg";
export { ForwardRef as ReactComponent };